/* tslint:disable */
/* eslint-disable */
/**
 * EMLINX API specification
 * This is API specification for EMLINX project.
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import { ErrorResponse } from '../models';
// @ts-ignore
import { ListCaseStatusCountResponse } from '../models';
/**
 * GetcasesstatuscountApi - axios parameter creator
 * @export
 */
export const GetcasesstatuscountApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * List cases status count
         * @summary GET Case status count
         * @param {Array<string>} [status] Case status
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listCaseStatusCount: async (status?: Array<string>, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/cases/status-count`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (status) {
                localVarQueryParameter['status'] = status;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * GetcasesstatuscountApi - functional programming interface
 * @export
 */
export const GetcasesstatuscountApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = GetcasesstatuscountApiAxiosParamCreator(configuration)
    return {
        /**
         * List cases status count
         * @summary GET Case status count
         * @param {Array<string>} [status] Case status
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listCaseStatusCount(status?: Array<string>, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ListCaseStatusCountResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listCaseStatusCount(status, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['GetcasesstatuscountApi.listCaseStatusCount']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
    }
};

/**
 * GetcasesstatuscountApi - factory interface
 * @export
 */
export const GetcasesstatuscountApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = GetcasesstatuscountApiFp(configuration)
    return {
        /**
         * List cases status count
         * @summary GET Case status count
         * @param {Array<string>} [status] Case status
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listCaseStatusCount(status?: Array<string>, options?: any): AxiosPromise<ListCaseStatusCountResponse> {
            return localVarFp.listCaseStatusCount(status, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * GetcasesstatuscountApi - object-oriented interface
 * @export
 * @class GetcasesstatuscountApi
 * @extends {BaseAPI}
 */
export class GetcasesstatuscountApi extends BaseAPI {
    /**
     * List cases status count
     * @summary GET Case status count
     * @param {Array<string>} [status] Case status
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GetcasesstatuscountApi
     */
    public listCaseStatusCount(status?: Array<string>, options?: RawAxiosRequestConfig) {
        return GetcasesstatuscountApiFp(this.configuration).listCaseStatusCount(status, options).then((request) => request(this.axios, this.basePath));
    }
}

